import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.regexp.test.js";
import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = {
  class: "conten"
};
var _hoisted_2 = {
  class: "hear"
};
var _hoisted_3 = {
  class: "detail"
};
var _hoisted_4 = {
  class: "hearText"
};

var _hoisted_5 = /*#__PURE__*/_createElementVNode("p", null, "内容详情", -1);

var _hoisted_6 = /*#__PURE__*/_createElementVNode("span", {
  class: "iconfont icon-jiaxingshoucang"
}, null, -1);

var _hoisted_7 = {
  class: "coll"
};
var _hoisted_8 = {
  class: "contentText"
};
var _hoisted_9 = {
  key: 0
};
var _hoisted_10 = {
  key: 1
};
var _hoisted_11 = {
  key: 0,
  class: "viide"
};
var _hoisted_12 = ["src"];
var _hoisted_13 = ["innerHTML"];
var _hoisted_14 = ["innerHTML"];
var _hoisted_15 = {
  class: "dow"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_Breads = _resolveComponent("Breads");

  var _component_DownFileList = _resolveComponent("DownFileList");

  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_Breads, {
    allpath: _ctx.detail.allPath
  }, null, 8, ["allpath"])]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_hoisted_5, _createElementVNode("div", {
    class: _normalizeClass({
      col: _ctx.col
    }),
    onClick: _cache[0] || (_cache[0] = //@ts-ignore
    function () {
      return _ctx.collect && _ctx.collect.apply(_ctx, arguments);
    })
  }, [_hoisted_6, _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.clow), 1)], 2)]), _createElementVNode("div", _hoisted_8, [_createElementVNode("p", null, _toDisplayString(_ctx.detail.list.title), 1), _ctx.detail.list.createTime ? (_openBlock(), _createElementBlock("span", _hoisted_9, "上传时间: " + _toDisplayString(_ctx.detail.list.createTime), 1)) : (_openBlock(), _createElementBlock("span", _hoisted_10, "上传时间: " + _toDisplayString(_ctx.detail.list.createDate), 1))]), _ctx.detail.list.videoUrl ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createElementVNode("video", {
    style: {
      "max-width": "600px",
      "max-heigth": "300px"
    },
    src: _ctx.videos,
    controls: ""
  }, null, 8, _hoisted_12)])) : _createCommentVNode("", true), _ctx.detail.list.content ? (_openBlock(), _createElementBlock("div", {
    key: 1,
    class: "con",
    innerHTML: _ctx.detail.list.content
  }, null, 8, _hoisted_13)) : (_openBlock(), _createElementBlock("div", {
    key: 2,
    class: "con",
    innerHTML: _ctx.detail.list.richText
  }, null, 8, _hoisted_14)), _createElementVNode("div", _hoisted_15, [_createVNode(_component_DownFileList, {
    ref: "downFileList",
    callback: true,
    onDosom: _ctx.test,
    onPickTiem: _ctx.test2
  }, null, 8, ["onDosom", "onPickTiem"])])])]);
}